exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-ledger-toggle-row .ledger-toggle-states--locked{opacity:.5;pointer-events:none}", ""]);

// exports
